function ClaimNumberValidation(claimNumber, isFormat2) {
  const crestClaimNumberFormat = /^[a-z]{3}[0-9]{4}$/i;
  const harpaClaimNumberFormat = /^[a-zA-Z]{6}[0-9]{6,7}$/;

  if (isFormat2) {
    return crestClaimNumberFormat.test(claimNumber);
  } else {
    return harpaClaimNumberFormat.test(claimNumber);
  }
}

export default ClaimNumberValidation;
